export default {
  "content": "<path d=\"M0 117V3a3 3 0 013-3h48.58a6 6 0 015.027 2.724l7.236 11.104a6 6 0 005.026 2.724H157a3 3 0 013 3V117a3 3 0 01-3 3H3a3 3 0 01-3-3z\" fill=\"#C7C7D4\"/>",
  "attrs": {
    "width": "160",
    "height": "120",
    "viewBox": "0 0 160 120",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};